import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class CompanyLink extends DomainObject {
  id;
  name;
  url;
  order;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      url: observable,
      order: observable
    });

    this.merge(other);
  }
}

export default CompanyLink;
